import type { ImportRow } from '../types';

type LivestockType = 'fish' | 'coral' | 'invertebrate' | 'plant';
type Currency = 'USD' | 'GBP' | 'EUR' | 'AUD' | 'CAD';

export interface BulkImportRequest {
  livestock_type: LivestockType;
  currency: Currency;
  items: Array<{
    common_name: string;
    scientific_name?: string | null;
    category?: string | null;
    subcategory?: string | null;
    vendor?: string | null;
    price_paid?: number | null;
    acquisition_date: string;
    status: string;
    notes?: string | null;
  }>;
  duplicate_decisions?: Array<{
    index: number;
    action: 'import' | 'skip';
  }>;
}

/**
 * Convert import rows to the API request format.
 * Only includes non-skipped rows.
 */
export function buildBulkRequest(
  rows: ImportRow[],
  livestockType: LivestockType,
  currency: Currency,
): BulkImportRequest {
  const items = rows
    .filter((row) => !row.isSkipped)
    .map((row) => ({
      common_name: row.name,
      scientific_name: row.scientificName || null,
      category: row.category?.value || null,
      subcategory: row.subcategory?.value || null,
      vendor: row.vendor || null,
      price_paid: row.price ?? null,
      acquisition_date: row.acquisitionDate || new Date().toISOString().slice(0, 10),
      status: row.status?.value || 'alive',
      notes: row.notes || null,
    }));

  return {
    livestock_type: livestockType,
    currency,
    items,
  };
}
